const initialState = {
  loading: false,
};

export function fetchIntervention(state = initialState, action) {
  switch (action.type) {
    case 'FETCH.INTERVENTION.SUCCESS':
    case 'SAVE.INTERVENTION_CONFIRMATION.SUCCESS':
      // If the ids are different, it means the user has openned another intervention
      // we then want to override the entire intervention object to avoid conflict with another intervention
      const receivedId = action.intervention.body.id;
      const previousId = state.intervention && state.intervention.id;
      if (!previousId || receivedId !== previousId) {
        return {
          ...state,
          intervention: action.intervention.body,
        }
      }
      return {
        ...state,
        intervention: {...state.intervention, ...action.intervention.body},
      };
    case 'SAVE.INTERVENTION_CONFIRMATION.REQUEST':
      return {
        ...state,
        confirmationInProgress: true,
      };
    case 'SAVE.INTERVENTION_CONFIRMATION.FAILURE':
      return {
        ...state,
        confirmationInProgress: false,
      };
    case 'HIDE_CONFIRM_INTERVENTION_MODAL':
      return {
        ...state,
        showModal: false,
        confirmationInProgress: false,
        error: undefined
      };
    case 'SHOW_CONFIRM_INTERVENTION_MODAL':
      return {
        ...state,
        showModal: true,
      };
    case 'FETCH.JOURNEY_COMMENT.SUCCESS':
    case 'DELETE.JOURNEY_COMMENT.SUCCESS':
      return {
        ...state,
        intervention: {...state.intervention, journeyComment: action.journeyComment.body},
      };
    case 'FETCH.JOURNEY_IDENTITY_DOCUMENTS.SUCCESS':
    case 'DELETE.JOURNEY_IDENTITY_DOCUMENTS.SUCCESS':
    case 'UPDATE.JOURNEY_IDENTITY_DOCUMENTS.SUCCESS':
      return {
        ...state,
        intervention: {...state.intervention, identityDocuments: action.journeyIdentityDocuments.body},
      };
    case 'FETCH.JOURNEY_DOCUMENTS.SUCCESS':
    case 'SAVE.JOURNEY_DOCUMENTS.SUCCESS':
    case 'DELETE.JOURNEY_DOCUMENTS.SUCCESS':
      return {
        ...state,
        intervention: {...state.intervention, documents: action.journeyDocuments.body}
      };
    case 'FETCH.JOURNEY_TIRE_OFFERS.SUCCESS':
    case 'SAVE.JOURNEY_TIRE_OFFERS.SUCCESS':
      return {
        ...state,
        intervention: {...state.intervention, tireOffers: action.tireOffers.body}
      };
    case 'DELETE.JOURNEY_TIRE_OFFERS.SUCCESS':
      delete state.intervention.tireOffers;
      return {
        ...state,
        intervention: {...state.intervention},
      };
    case 'FETCH.CONVERSATION.SUCCESS':
    case 'SAVE.CONVERSATION_MARK_AS_READ.SUCCESS':
      return {
        ...state,
        intervention: {...state.intervention, conversation: action.conversation.body},
      };
    case 'SAVE.NEW_MESSAGE_RECEIVED.SUCCESS':
      let conversation = state.intervention.conversation;
      conversation.lastMessageHandled = action.message.message.internal;
      conversation.messages.push(action.message.message);
      return {
        ...state,
        intervention: {...state.intervention, conversation: {...conversation}}
      };
    case 'SAVE.MESSAGE_READ.SUCCESS':
      const {readAcknowledge} = action;
      state.intervention.conversation.messages.forEach(message => {
        if (message.id <= readAcknowledge.messageId) {
          message.read = true;
          message.readAt = readAcknowledge.readAt;
        }

      });
      return {
        ...state,
      };
    case 'FETCH.INTERVENTION_STATUS.SUCCESS':
      const {status, prevStatus, advisor} = action.status.body;
      return {
        ...state,
        intervention: {...state.intervention, status, prevStatus, advisor}
      };
    default:
      return state
  }
}

export function saveJourneyDocuments(state = initialState, action) {
  switch (action.type) {
    case 'SAVE.JOURNEY_DOCUMENTS.SUCCESS':
      return {
        ...state,
        documents: action.journeyDocuments.body
      };
    default:
      return state
  }
}
